const Data = [
    {
        type: "QCM",
        title: "Avec quelle(s) propositions êtes-vous d’accord ?",
        r: [
            "Mon écho met en évidence une HVG : c’est une CMH sarcomérique certaine",
            "Mon écho ne met pas en évidence d’HVG : je demande un scanner coronaire",
            "Mon écho ne met pas en évidence d’HVG : ce n’est pas une CMH",
            "Mon écho ne met pas en évidence d’HVG : je demande une IRM",
            "Mon écho met en évidence une HVG : je demande une IRM",
        ],
        qcm: true,
        puces: true,
    },
    {
        type: "QCM",
        title: "Notre patient a une CMH symptomatique (dyspnée d’effort et douleurs thoraciques post-prandiales), et un gradient maximal d’obstruction à 20 mm Hg. Qu’en pensez-vous ?",
        r: [
            "C’est une CMH non obstructive",
            "Il faut rechercher une autre cause à ses symptômes",
            "Il faut l’explorer à l’effort",
            "Il faut l’explorer en post-prandial",
        ],
        qcm: true,
        puces: true,
    },
    {
        type: "QCM",
        title: "Notre patient a été traité en raison d’une obstruction latente, il se dit asymptomatique mais le gradient maximal lors de la manœuvre de Valsalva est inchangé à 55 mm Hg. Que proposez-vous ?",
        r: [
            "Rendez-vous dans 6 mois et je ne ferai plus la manœuvre de Valsalva, il est asymptomatique",
            "Je dose des biomarqueurs sanguins",
            "Je le réévalue à l’effort",
            "Je refais une IRM cardiaque"
        ],
        qcm: true,
        puces: true,
    },
]

export default Data;